module Meevo.Plugins.Register {
    export class MeevoRegisterNavigationHeader implements angular.IDirective {
        restrict = "E";

        scope = {
            register: "=",
            primaryNavigationSection: "=?",
            isPayment: "=?",
            selectedCategory: "=?",
            selectedSection: "@?",
            contentKey: "@",
            hasSubCategory: "@?"
        };

        templateUrl = "app/plugins/register/directives/registerNavigationHeader.template.html";

        link = (scope: any) => {
            if (!scope.isPayment) {
                scope.isPayment = false;
            }

            if (scope.hasSubCategory == undefined) {
                scope.hasSubCategory = true;
            }

            scope.loadContextData = () => {
                scope.section = scope.register.context.selectedSection;
            }

            scope.showBackButton = (selectedSection: string) => {
                if (scope.register.context.isRefundMode && scope.register.context.selectedSection.sectionType !== RegisterSectionTypeEnum.RefundOptions) {
                    return true;
                }

                switch (selectedSection) {
                    case 'services':
                        if (!scope.register.context.selectedSection.showTransactionSearch) {
                            return !!scope.register.context.selectedSection.selectedServiceCat;
                        } else {
                            return false;
                        }

                    case 'products':
                        if (!scope.register.context.selectedSection.showTransactionSearch) {
                            return !!scope.register.context.selectedSection.selectedProductCat;
                        } else {
                            return false;
                        }
                    case "giftcard":
                        return angular.isFunction(scope.register.context.selectedSection.canGoBack) &&
                            scope.register.context.selectedSection.canGoBack();
                    case 'creditPayments':
                    case 'cashPayments':
                    case 'checkPayments':
                    case 'giftCardPayments':
                    case 'clientPointsPayments':
                    case 'clientAccountPayments':
                    case 'otherPayments':
                    case 'refundReasons':
                    case 'employeeSelection':
                    case 'pointsRewards':
                    case 'selfPayments':
                    case 'paymentPlanPayments':
                    case 'careCreditPayments':
                    case 'productUsage':
                        return true;

                    case 'teacherSelection':
                        return scope.register.context.selectedSection.sectionType === RegisterSectionTypeEnum.Employee;

                    case 'clientAccounts':
                        return scope.register.context.selectedSection.stage === ClientAccountSaleStageEnum.Refund ||
                               (scope.register.context.selectedSection.stage !== ClientAccountSaleStageEnum.Initial && !scope.register.context.selectedSection.isEditing);

                    case 'refundOptions':
                        return false;
                        
                    default:                    
                        //console.debug(`registerNavigationHeader - showBackButton - ${selectedSection}`);
                        return !!scope.selectedCategory;
                }
            }

            scope.disableHandler = () => {
                switch (scope.selectedSection) {
                    case 'employeeSelection':
                        return false;

                    default:
                        scope.register.context.disabledNavigation(scope.deviceParams, scope.selectedCategory);
                }
            }

            scope.isOptionSection = () => {
                return scope.register.context.selectedSection.sectionType !== RegisterSectionTypeEnum.RefundOptions &&
                       scope.register.context.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentOptions;
            }

            scope.clickHandler = () => {
                const navigateToPaymentOptions = () => {
                    scope.register.context.navigate(
                        scope.primaryNavigationSection,
                        scope.selectedCategory,
                        scope.isPayment,
                        true,
                        scope.register.context.isRefundMode);
                }

                const navigateToRefundOptions = () => {
                    scope.register.context.navigate(
                        RegisterSectionTypeEnum.RefundOptions,
                        scope.selectedCategory,
                        scope.isPayment,
                        true,
                        scope.register.context.isRefundMode);
                }

                switch (scope.selectedSection) {
                    case 'clientAccounts':
                        if (scope.register.context.isRefundMode) {
                            navigateToRefundOptions();
                            break;
                        }

                        //if the section stage is initial then do the default nav else go back go initial state
                        if (scope.register.context.selectedSection.stage === ClientAccountSaleStageEnum.Initial) {
                            navigateToPaymentOptions();
                            break;
                        }

                        //returning to the intial screen should show checkout options
                        scope.register.context.selectedSection.initialStage();
                        break;

                    case 'giftcard':
                        if (scope.register.context.isRefundMode) {
                            navigateToRefundOptions();
                            break;
                        }

                        if (scope.register.context.selectedSection.stage != GiftCardStageEnum.Quantity) {
                            scope.register.context.selectedSection.goBack();
                        }
                        
                        if (device.mobile() || (device.portrait() && device.tablet() && !device.largeTablet() )) {
                            //device is a mobile device or an ipad in portrait
                            navigateToPaymentOptions();
                        }
                        break;

                    case 'employeeSelection':
                        scope.register.context.selectSection(scope.register.context.previouslySelectedSection.sectionType, scope.register.context.isRefundMode);
                        break;

                    case 'productLot':
                        scope.register.context.selectSection(RegisterSectionTypeEnum.Products, scope.register.context.isRefundMode);
                        break;

                    case 'refundReasons':
                        scope.register.context.selectSection(scope.register.context.previouslySelectedSection.sectionType, false);
                        break;
                    
                    case 'creditPayments':
                    case 'careCreditPayments':
                        if (scope.register.context.selectedSection.displayPaymentAmount && scope.register.context.selectedSection.creditCardList.length > 0) {
                            scope.register.context.selectedSection.displayPaymentAmount = false;
                            break;
                        }

                        scope.register.context.cancelPendingHostedPagePayments().finally(() => {
                            navigateToPaymentOptions();
                        });
                        break;

                    case 'otherPayments':
                        navigateToPaymentOptions();
                        break;

                    case 'products':
                        if (scope.register.context.selectedSection.selectedProductCat
                            && scope.register.context.selectedSection.selectedProductCat.prefix
                            && scope.register.context.selectedSection.selectedProductCat.prefix === scope.register.context.selectedSection.ShopSupply.displayName) {
                            scope.register.context.selectedSection.selectionMode = ProductSelectionMode.Shop;
                            scope.register.context.selectedSection.selectedProductCat = scope.register.context.selectedSection.ShopSupply
                        } else {
                            scope.register.context.isRefundMode
                                ? navigateToRefundOptions()
                                : navigateToPaymentOptions();
                        }
                        break;

                    case 'productUsage':
                        scope.register.context.selectedSection.clear(false);
                        break;

                    default:
                        //console.debug(`registerNavigationHeader - clickHandler - ${scope.selectedSection}`);
                        scope.register.context.isRefundMode
                            ? navigateToRefundOptions()
                            : navigateToPaymentOptions();
                        break;
                }
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoRegisterNavigationHeader();
            };

            return directive;
        }
    }

    angular.module("meevo.plugins.register")
        .directive("meevoRegisterNavigationHeader", MeevoRegisterNavigationHeader.factory());
}